import cn from 'classnames';

import { Typography } from '@sravni/react-design-system';
import { Divider } from '@sravni/react-design-system/lib/Divider';
import { useIsPhone } from '@sravni/react-utils';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import { OZON_PRIZE_TEXT } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/constants';
import { getHiddenPhoneNumber } from '@src/components/OctoberPrizeDraw/utils';

import styles from './styles.module.scss';

type WinnerItemProps = {
  winner: Winner;
  isLast: boolean;
};

const { Heading, Text } = Typography;

export const WinnerItem = ({ winner, isLast }: WinnerItemProps) => {
  const hiddenPhone = getHiddenPhoneNumber(winner.phoneNumber);
  const isPhone = useIsPhone();

  return (
    <>
      <div key={winner.id} className={styles.row}>
        <Heading level={isPhone ? 5 : 4} className={styles.cell}>
          {hiddenPhone}
        </Heading>

        {isPhone ? (
          <div className={styles.cell}>
            <Text size={8} className="h-color-D40">
              {OZON_PRIZE_TEXT}
            </Text>
            <Heading level={6}>{winner.amount}</Heading>
          </div>
        ) : (
          <>
            <Text size={16} className={cn(styles.cell, 'h-color-D40')}>
              {OZON_PRIZE_TEXT}
            </Text>
            <Heading level={4} className={styles.cell}>
              {winner.amount}
            </Heading>
          </>
        )}
      </div>
      {!isLast && <Divider />}
    </>
  );
};
